import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import type React from 'react';
import type { RefObject } from 'react';
interface Props {
  children: React.ReactNode;
  scrollRef: RefObject<HTMLDivElement | null>;
}
function ChatListLayout(t0) {
  const $ = _c(6);
  const {
    children,
    scrollRef
  } = t0;
  const pcFontSize = useChatPanelStore(_temp);
  let t1;
  if ($[0] !== pcFontSize) {
    const fontSizeClass = cn({
      "text-[13px]": pcFontSize === 13,
      "text-[15px]": pcFontSize === 15,
      "text-[19px]": pcFontSize === 19
    });
    t1 = cn("scrollbar-custom flex flex-1 flex-col overflow-y-auto p-[12px]", fontSizeClass);
    $[0] = pcFontSize;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== scrollRef || $[4] !== t1) {
    t2 = <div className={t1} ref={scrollRef}>{children}</div>;
    $[2] = children;
    $[3] = scrollRef;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(state) {
  return state.pcFontSize;
}
export default ChatListLayout;